import React, { useEffect, useState } from "react";
import {
  PersonalDetials,
  ContactDetails,
  BankDetails,
  PaymentDetails,
  Settings,
} from "./";
import style from "./profile.module.scss";
import AlertMessage from "../common/AlertMessage";
import { useTranslation } from "react-i18next";
import { Col, Row } from "react-bootstrap";
import AppInfoservice from "../../../service/common/Appinfo";
function EditContent(props) {
  console.log("edit content props", props.detailsDisable);
  const detailsDisable = props.detailsDisable;
  const { t } = useTranslation();
  const [state, setState] = useState({
    EditPerosal: true,
    EditContact: true,
    EditBankDetails: true,
    EditPaymentDetials: true,
    EditSettingsDetails: true,
    loader: false,
  });
  const notifyInintialState = {
    show: false,
    message: "",
    type: "",
    header: "",
  };
  const [notify, setNotify] = useState(notifyInintialState);
  const {
    EditPerosal,
    EditContact,
    EditBankDetails,
    EditPaymentDetials,
    EditSettingsDetails,
  } = state;
  const editButtonClick = (key) => {
    cancelbtn();
    setState((prev) => ({
      ...prev,
      [key]: false,
    }));
  };
  //cancel button click
  const cancelbtn = () => {
    Object.keys(state).forEach((i) => {
      setState((prev) => ({
        ...prev,
        [i]: true,
      }));
    });
  };
  const notifyDissmissed = () => {
    setNotify((prev) => ({
      ...prev,
      show: false,
    }));
  };
  const showNotify = (type, header, message) => {
    setNotify((prev) => ({
      ...prev,
      show: true,
      type: type,
      header: t("Common." + header),
      message: t(message),
    }));
  };

  const [uploadedData, setUploadedData] = useState(null);
  console.log("🚀Data:", uploadedData);
  console.log(" state details", state);
  const fetchData = async () => {
    const service = new AppInfoservice();
    const res = await service.get_layout();
    if (res) {
      console.log("🚀00000 uploaded dara", res.data.uploaded);
      setUploadedData(res.data.uploaded); // Set the response to the state
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  // cancelbtn();
  return (
    <div className={style.EditContent}>
      <PersonalDetials
        uploadedData={uploadedData} // Pass the uploadedData state as a prop
        detailsDisable={detailsDisable}
        status={"EditPerosal"}
        change={editButtonClick}
        isEditable={EditPerosal}
        cancelbtn={cancelbtn}
        data={props.editData.personal_details.fields}
        updateSuccess={props.updateSuccess}
        stateKey="personal_details"
        showNotify={showNotify}
        getData={props.getData}
        primary={props.primary}
      />
      <br />
      <ContactDetails
        detailsDisable={detailsDisable}
        uploadedData={uploadedData} // Pass the uploadedData state as a prop
        status={"EditContact"}
        change={editButtonClick}
        isEditable={EditContact}
        cancelbtn={cancelbtn}
        data={props.editData.contact_details.fields}
        updateSuccess={props.updateSuccess}
        stateKey="contact_details"
        showNotify={showNotify}
        getData={props.getData}
        primary={props.primary}
      />
      <br />

      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <Row>
          <Col md={10}>
            <BankDetails
              detailsDisable={detailsDisable}
              status={"EditBankDetails"}
              change={editButtonClick}
              isEditable={EditBankDetails}
              cancelbtn={cancelbtn}
              data={props.editData.bank_details.fields}
              updateSuccess={props.updateSuccess}
              stateKey="bank_details"
              showNotify={showNotify}
              getData={props.getData}
              extraDetails={props?.extraDetails}
              primary={props.primary}
              props={props}
            />
          </Col>
        </Row>{" "}
        &nbsp;&nbsp;&nbsp;
        {props.editData.settings_details && (
          <Settings
            detailsDisable={detailsDisable}
            status={"EditSettingsDetails"}
            change={editButtonClick}
            isEditable={EditSettingsDetails}
            cancelbtn={cancelbtn}
            data={props.editData.settings_details.fields}
            updateSuccess={props.updateSuccess}
            stateKey="settings_details"
            showNotify={showNotify}
            getData={props.getData}
            primary={props.primary}
          />
        )}
      </div>

      <br />
      {/* {props.editData?.payment_details?.fields &&
                <PaymentDetails
                    status={'EditPaymentDetials'}
                    // change={editButtonClick}
                    // isEditable={EditPaymentDetials}
                    cancelbtn={cancelbtn}
                    data={props.editData.payment_details.fields}
                    updateSuccess={props.updateSuccess}
                    stateKey="payment_details"
                    showNotify={showNotify}
                    getData={props.getData}
                />
            } */}
      <br />

      {notify.show && (
        <div>
          <AlertMessage
            message={notify.message}
            dismiss={notifyDissmissed}
            type={notify.type}
            header={notify.header}
            show={notify.show}
          />
        </div>
      )}
    </div>
  );
}

export default EditContent;
